import React from "react";
import Select from "react-select";

const AddJobSkill = () => {
  const Categories = [
    { value: "Choose", label: "Choose" },
    { value: "Software Development", label: "Software Development" },
    { value: "Data Science", label: "Data Science" },
    { value: "Marketing", label: "Marketing" },
  ];
  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightNewJobSkill"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "40%", maxWidth: "40%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">New Job Skill</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Skill</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Skill Name"
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Category</label>
                  <Select
                    classNamePrefix="react-select"
                    options={Categories}
                    placeholder="Select a Category"
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Description</label>
                  <textarea type="text" className="form-control" />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary d-flex mt-3 me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary d-flex mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddJobSkill;
